import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";

const CoachMarkStep4 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop_with_img}>
                <div className={css.higlight4}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                    
                    <div className={css.content}>
                        <i class="fi fi-rr-cross-small"></i>
                        <div className={css.title}>🚦 Error Information Status</div>
                        <div className={css.desc}>This is Error Information Status section! Here, you'll find important warnings categorized into four levels: Critical, Major, Minor, and Warning. Keep an eye on these statuses to stay informed about your system's health and performance!</div>
                        <div className={css.step}>4/10</div>
                        <NavLink to="/home" onClick={props.prev}>
                            <button className={css.prev}>Previous</button>
                        </NavLink>
                        <NavLink to="/home" onClick={props.next}>
                            <button className={css.next}>Next</button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep4;
